import * as React from 'react';

import { Helmet } from 'react-helmet-async';

import { ProductsReportForm, ProductsReportHeader } from './components';

export default function ProductsReport() {
  return (
    <React.Fragment>
      <Helmet>
        <title>گزارش‌ محصول‌ها | کاشی لند</title>
      </Helmet>
      <ProductsReportHeader />
      <ProductsReportForm />
    </React.Fragment>
  );
}
